var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormItemWrapper',{attrs:{"minimal":true,"size":"sm"}},[_c('el-select',{attrs:{"placeholder":_vm.$t('formItemSortByPlaceholder')},model:{value:(_vm.sort),callback:function ($$v) {_vm.sort=$$v},expression:"sort"}},_vm._l((_vm.sortOptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }